import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeContext = createContext({ me: null, loading: true, refresh: () => {} });

export function MeProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!isSignedIn) {
      setMe(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/me");
      setMe(data);
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, [api, isSignedIn]);

  useEffect(() => {
    if (isLoaded) {
      refresh();
    }
  }, [isLoaded, refresh]);

  return <MeContext.Provider value={{ me, loading: loading || !isLoaded, refresh }}>{children}</MeContext.Provider>;
}

export const useMe = () => useContext(MeContext);
